// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3vmth","colMaxWidth":"Table_colMaxWidth__39h3K"};